module.exports = __webpack_public_path__ + "img/user.2a56a2ef.svg";